if (typeof adrnlHeader !== 'function') {
    class adrnlHeader extends HTMLElement {
        constructor() {
            super();
            this.headerHolder = document.querySelector('[data-header-holder]');
            this.submenuTrigger = this.querySelectorAll('[data-submenu-trigger]');
            this.thirdmenuTrigger = this.querySelectorAll('[data-thirdmenu-trigger]');
            this.submenues = this.querySelectorAll('.sub-menu');
            this.thirdsMenues = this.querySelectorAll('.third-menu');
            this.currentTarget = undefined;
            this.currentThirdTarget = undefined;

            this.triggerOpenMenuMobile = this.querySelectorAll('[data-mobile-nav-trigger]');
            this.triggerDismissMenuMobile = this.querySelectorAll('[data-menu-dismiss]');
            this.menuBack = this.querySelectorAll('[data-menu-back]');
            this.mobileNav = this.querySelector('[data-mobile-menu]');
            this.submenuMobileTrigger = this.querySelectorAll('[data-mobile-submenu-trigger]');
            this.submenuesMobile = this.querySelectorAll('[data-submenu-mobile-item]');

            this.announceBar = this.querySelector('[data-header-announcement]');
            this.waitForSlick();

            this.searchDrawer = this.querySelector('search-drawer');
          this.searchDrawerHolder = this.querySelector('[data-search-drawer-holder]');
            this.searchTrigger = this.querySelectorAll('[data-search-trigger]');

            if (this.searchTrigger) {
              this.searchTrigger.forEach((ele) => {
                ele.addEventListener('click', () => {
                        this.openSearchDrawer();
                })
              })
            }

            this.initEventListeners();
            document.addEventListener('click', this.handleOutsideClick.bind(this));

            if (this.triggerOpenMenuMobile) {
                this.triggerOpenMenuMobile.forEach((ele) => {
                    ele.addEventListener('click', () => {
                        this.openNavMobile();
                    })
                })
            }
            if (this.triggerDismissMenuMobile) {
                this.triggerDismissMenuMobile.forEach((ele) => {
                    ele.addEventListener('click', () => {
                        this.dismissNavMobile();
                    })
                })
            }

            if (this.submenuMobileTrigger) {
                this.submenuMobileTrigger.forEach((ele) => {
                    ele.addEventListener('click', (event) => {
                        event.preventDefault();
                        const target = ele.getAttribute('data-mobile-submenu-trigger');
                        console.log('target', target);
                        this.openSubmenuMobile(target);
                    })
                })
            }

            if (this.menuBack) {
                this.menuBack.forEach((btn) => {
                    btn.addEventListener('click', (e) => {
                        this.resetMenuMobile();
                    })
                })
            }

            window.addEventListener('scroll', () => {
                if (window.scrollY > 100) {
                    this.headerHolder.classList.add('sticky-header');
                    document.body.classList.add('scroll-sticky');
                } else {
                    this.headerHolder.classList.remove('sticky-header');
                    document.body.classList.remove('scroll-sticky');
                }
            });
        }

      openSearchDrawer() {
        if (this.searchDrawer) {
          this.searchDrawer.classList.add('open');
          document.body.classList.add('overflow-hidden');
        }
      }

      closeSearchDrawer() {
        if (this.searchDrawer) {
          this.searchDrawer.classList.remove('open');
          document.body.classList.remove('overflow-hidden');
        }
      }

        resetMenuMobile() {
            this.mobileNav.classList.add('first-step');
        }

        openSubmenuMobile(target) {
            this.mobileNav.classList.remove('first-step');
            this.submenuesMobile.forEach((ele) => {
                if (ele.getAttribute('data-submenu-mobile-item') === target) {
                    ele.setAttribute('aria-hidden', false);
                } else {
                    ele.setAttribute('aria-hidden', true);
                }
            })
        }

        openNavMobile() {
            this.mobileNav.classList.add('open');
            this.mobileNav.classList.add('first-step');
        }

        dismissNavMobile() {
            this.mobileNav.classList.remove('open');
            this.mobileNav.classList.add('first-step');
        }

        initEventListeners() {
            if (this.submenuTrigger) {
                this.submenuTrigger.forEach((button) => {
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        const target = button.getAttribute('data-submenu-trigger');
                        this.resetSubmenus(target);
                    });
                });
            }

            if (this.thirdmenuTrigger) {
                this.thirdmenuTrigger.forEach((button) => {
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        const target = button.getAttribute('data-thirdmenu-trigger');
                        this.resetThirdsmenus(target);
                    });
                });
            }
        }

        resetThirdsmenus(target) {
            if (target !== this.currentThirdTarget) {
                this.thirdsMenues.forEach((ele) => {
                    ele.setAttribute('aria-hidden', ele.getAttribute('data-thirdmenu') !== target);
                });
                this.thirdmenuTrigger.forEach((ele) => {
                    ele.classList.toggle('menu-active', ele.getAttribute('data-thirdmenu-trigger') === target);
                });
                this.currentThirdTarget = target;
            } else {
                this.closeThirdMenus();
            }
        }

        resetSubmenus(target) {
            if (target !== this.currentTarget) {
                this.submenues.forEach((ele) => {
                    ele.setAttribute('aria-hidden', ele.getAttribute('data-submenu') !== target);
                });
                this.submenuTrigger.forEach((ele) => {
                    ele.classList.toggle('menu-active', ele.getAttribute('data-submenu-trigger') === target);
                });
                this.currentTarget = target;
            } else {
                this.closeSubmenus();
            }
        }

        closeThirdMenus() {
            this.thirdsMenues.forEach(ele => ele.setAttribute('aria-hidden', true));
            this.thirdmenuTrigger.forEach(ele => ele.classList.remove('menu-active'));
            this.currentThirdTarget = undefined;
        }

        closeSubmenus() {
            this.submenues.forEach(ele => ele.setAttribute('aria-hidden', true));
            this.submenuTrigger.forEach(ele => ele.classList.remove('menu-active'));
            this.currentTarget = undefined;
        }

        handleOutsideClick(event) {
            if (this.searchDrawerHolder && !this.searchDrawerHolder.contains(event.target) && !event.target.closest('[data-search-trigger]')) {
                this.closeSearchDrawer();
            }
            if (!this.contains(event.target)) {
                this.closeSubmenus();
                this.closeThirdMenus();
                this.dismissNavMobile();
            }
        }

        waitForSlick() {
            const checkSlicknA = setInterval(() => {
                if (window.jQuery && typeof jQuery.fn.slick !== 'undefined') {
                    clearInterval(checkSlicknA);
                    this.initSlick();
                }
            }, 100);
        }

        initSlick() {
            if (!this.announceBar) return;

          const $announceBar = jQuery(this.announceBar);
          if ($announceBar.children().length <= 1) return;

                if (window.jQuery) {
                    jQuery(this.announceBar).slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow:1,
                        slidesToScroll: 1,
                        speed: 300,
                        autoplay: true,
                        autoplaySpeed: 4000
                    });
                }
        }
    }

    if (typeof customElements.get('adrnl-header') == 'undefined') {
        customElements.define('adrnl-header', adrnlHeader);
    }
}

